<template>
  <v-chip
    outlined
    class="app-chip"
    :color="resolvedColor"
    :text-color="resolvedColor"
    :small="small"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-icon v-if="showDot" left x-small :color="resolvedColor"> mdi-checkbox-blank-circle </v-icon>

    <slot v-if="$slots.default" />

    <template v-else>
      {{ resolvedLabel }}
    </template>
  </v-chip>
</template>

<script>
export default {
  name: 'AppChip',

  props: {
    value: {
      default: null,
    },

    items: {
      type: Array,
      default: () => [],
    },

    color: {
      type: String,
      default: null,
    },

    label: {
      type: String,
      default: null,
    },

    fallbackColor: {
      type: String,
      default: 'grey',
    },

    fallbackLabel: {
      type: String,
      default: '—',
    },

    small: {
      type: Boolean,
      default: true,
    },

    showDot: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    resolved() {
      if (!this.items.length) return null

      return this.items.find(item => item.value === this.value || item.value === String(this.value))
    },

    resolvedColor() {
      return this.color || this.resolved?.color || this.fallbackColor
    },

    resolvedLabel() {
      return this.label || this.resolved?.text || this.resolved?.label || this.fallbackLabel
    },
  },
}
</script>

<style scoped>
.app-chip {
  background-color: white !important;
  font-weight: 500;
  font-size: 11px !important;
  border-width: 1.5px !important;
  white-space: nowrap;
  width: fit-content !important;
}

::v-deep .app-chip.v-chip {
  padding: 0 9px !important;
  height: 26px !important;
  max-width: none !important;
}

::v-deep .app-chip .v-chip__content {
  color: inherit !important;
}

::v-deep .app-chip .v-icon {
  color: inherit !important;
}
</style>
